module.exports = __webpack_public_path__ + "static/media/order-card-sample.ae7ff36a.csv";